export default "__VITE_ASSET__BLiZYyM9__"